import React from "react";

type ChipImageProps = {
  styles: React.CSSProperties;
  alt: string;
  id: string;
  icon: string;
};

function ChipImage(props: ChipImageProps) {
  const { styles, alt, id, icon } = props;
  return <img style={styles} src={icon} alt={alt} data-tip data-for={id} />;
}

export default ChipImage;
